"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.language = exports.conf = void 0;
exports.conf = {
    comments: {
        lineComment: '#',
    },
    brackets: [
        ['{', '}'],
        ['[', ']'],
        ['(', ')'],
    ],
    autoClosingPairs: [
        { open: '{', close: '}' },
        { open: '[', close: ']' },
        { open: '(', close: ')' },
        { open: '"""', close: '"""', notIn: ['string', 'comment'] },
        { open: '"', close: '"', notIn: ['string', 'comment'] },
    ],
    surroundingPairs: [
        { open: '{', close: '}' },
        { open: '[', close: ']' },
        { open: '(', close: ')' },
        { open: '"""', close: '"""' },
        { open: '"', close: '"' },
    ],
    folding: {
        offSide: true,
    },
};
exports.language = {
    defaultToken: 'invalid',
    tokenPostfix: '.gql',
    keywords: ['null', 'true', 'false', 'query', 'mutation', 'subscription', 'schema', 'implements', 'fragment', 'on'],
    inputs: ['input'],
    types: ['type'],
    interfaces: ['interface'],
    enums: ['enum'],
    unions: ['union'],
    scalars: ['scalar'],
    extends: ['extend'],
    directives: ['directive'],
    typeKeywords: ['Int', 'Float', 'String', 'Boolean', 'ID'],
    directiveLocations: [
        'SCHEMA',
        'SCALAR',
        'OBJECT',
        'FIELD_DEFINITION',
        'ARGUMENT_DEFINITION',
        'INTERFACE',
        'UNION',
        'ENUM',
        'ENUM_VALUE',
        'INPUT_OBJECT',
        'INPUT_FIELD_DEFINITION',
        'QUERY',
        'MUTATION',
        'SUBSCRIPTION',
        'FIELD',
        'FRAGMENT_DEFINITION',
        'FRAGMENT_SPREAD',
        'INLINE_FRAGMENT',
        'VARIABLE_DEFINITION',
    ],
    operators: ['=', '!', '?', ':', '&', '|'],
    symbols: /[=!?:&|]+/,
    escapes: /\\(?:["\\\/bfnrt]|u[0-9A-Fa-f]{4})/,
    tokenizer: {
        root: [
            [
                /\!/,
                {
                    token: 'exclamation',
                },
            ],
            [
                /[a-z_$][\w$]*/,
                {
                    cases: {
                        '@keywords': 'keyword',
                        '@inputs': 'input',
                        '@types': 'type',
                        '@interfaces': 'interface',
                        '@enums': 'enum',
                        '@unions': 'union',
                        '@scalars': 'scalar',
                        '@extends': 'extend',
                        '@directives': 'directive',
                        '@default': 'identifier',
                    },
                },
            ],
            [
                /[A-Z][\w\$]*/,
                {
                    cases: {
                        '@typeKeywords': 'scalar',
                        '@default': 'identifier',
                    },
                },
            ],
            [
                /@[\w\$]*/,
                {
                    cases: {
                        '@default': 'identifier',
                    },
                },
            ],
            { include: '@whitespace' },
            [/[{}()\[\]]/, '@brackets'],
            [/@symbols/, { cases: { '@operators': 'operator', '@default': '' } }],
            [/\d*\.\d+([eE][\-+]?\d+)?/, 'number.float'],
            [/0[xX][0-9a-fA-F]+/, 'number.hex'],
            [/\d+/, 'number'],
            [/[;,.]/, 'delimiter'],
            [`"""`, { token: 'string.doc', next: '@mlstring', nextEmbedded: 'markdown' }],
            [/"([^"\\]|\\.)*$/, 'string.invalid'],
            [/"/, { token: 'string.quote', bracket: '@open', next: '@string' }],
        ],
        mlstring: [[`"""`, { token: 'string.doc', next: '@pop', nextEmbedded: '@pop' }]],
        string: [
            [/[^\\"]+/, 'string'],
            [/@escapes/, 'string.escape'],
            [/\\./, 'string.escape.invalid'],
            [/"/, { token: 'string.quote', bracket: '@close', next: '@pop' }],
        ],
        whitespace: [
            [/[\s\t\r\n]+/, ''],
            [/#.*$/, 'comment'],
        ],
    },
};
